import React, { useEffect, useState } from 'react';
import ReactECharts from 'echarts-for-react';
import { Typography, Box, Paper, Divider } from '@material-ui/core';
import Filter from '../../../components/Dashboard/Filter/6level';
import MaterialTable from 'material-table';
import { tableIcons } from '../../../configs/ui/TableConfig';
import Axios from 'axios';
import { useSnackbar } from 'notistack';
import {
   graph_mock,
   topEmployee_mock,
} from '../../../mockdata/dashboard/mock-graph-5';
import { makeStyles } from '@material-ui/core/styles';
import EmptyChart from '../../../components/Dashboard/Chart/EmptyChart';
import LoadingChart from '../../../components/Dashboard/Chart/LoadingChart';
import DownloadPDFButton from '../../../components/Dashboard/Button/DownloadPDF';
import { useLocation } from 'react-router-dom';
import FileSaver from 'file-saver';
import DownloadExcelButton from '../../../components/Dashboard/Button/DownloadExcel';

let mock = false;

const useStyles = makeStyles((theme) => ({
   descContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
   },
   loading: {
      height: '300px',
      width: '100%',
      backgroundColor: '#F2F2F2',
      borderRadius: '5px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
   },
   graphsContainer: {
      width: '100%',
      display: 'flex',
   },
   usedPointFlag: {
      width: 30,
      height: 15,
      backgroundColor: '#EC068D',
      borderRadius: '2px',
   },
   remainPointFlag: {
      width: 30,
      height: 15,
      backgroundColor: '#CCCCCC',
      borderRadius: '2px',
   },
   tablesContainer: {
      backgroundColor: 'white',
      height: '100%',
   },
}));

const PointAndRedeem = () => {
   const classes = useStyles();
   const { enqueueSnackbar, closeSnackbar } = useSnackbar();
   const [isLoadingGraph, setIsLoadingGraph] = useState(false);
   const [chartData, setChartData] = useState();
   const [MultiTable, setMultiTable] = useState(null);
   const [isLoadingMultiTable, setIsLoadingMultiTable] = useState(false);
   const [filtersData, setFiltersData] = useState();
   const location = useLocation();
   const [isLoadingExcel, setIsLoadingExcel] = useState(false);
   const getChartsOptionsDefault = () => {
      let option = {
         tooltip: {
            trigger: 'axis',
            axisPointer: {
               type: 'cross',
               label: {
                  backgroundColor: '#6a7985',
               },
            },
         },
         legend: {
            data: ['ผู้เข้าใช้งาน', 'ผู้เข้าร่วมกิจกรรม', 'ผู้แลกของรางวัล'],
         },
         grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true,
         },
         xAxis: [
            {
               name: 'วัน',
               type: 'category',
               boundaryGap: false,
               data: null,
               axisLabel: { rotate: 45 },
            },
         ],
         yAxis: [
            {
               type: 'value',
            },
         ],
         series: [
            {
               smooth: true,
               name: 'ผู้เข้าใช้งาน',
               type: 'line',
               stack: 'Total',
               areaStyle: {},
               emphasis: {
                  focus: 'series',
               },
               data: null,
            },
            {
               smooth: true,
               name: 'ผู้เข้าร่วมกิจกรรม',
               type: 'line',
               stack: 'Total',
               areaStyle: {},
               emphasis: {
                  focus: 'series',
               },
               data: null,
            },
            {
               smooth: true,
               name: 'ผู้แลกของรางวัล',
               type: 'line',
               stack: 'Total',
               areaStyle: {},
               emphasis: {
                  focus: 'series',
               },
               data: null,
            },
         ],
      };
      return option;
   };
   const onFiltersSubmit = (filters) => {
      setFiltersData(filters);
      let payload = {
         divisionList: filters.shortCodes,
         startDate: filters.startDateString,
         endDate: filters.endDateString,
      };
      if (mock) {
         setIsLoadingGraph(true);
         setTimeout(() => {
            setIsLoadingGraph(false);
            setChartData(graph_mock.graph);
         }, 1000);
      } else {
         setIsLoadingGraph(true);
         Axios.post('/GSB/dashboard/dashboard/GetEmployeeActionGraph', payload)
            .then((resp) => {
               setChartData(resp.data.graph);
               // enqueueSnackbar('ดึงข้อมูลกราฟสำเร็จ', { variant: 'success' });
            })
            .catch((e) => {
               setChartData(null);
               if (e.response) {
                  const response = e.response.data;
                  enqueueSnackbar(response.errorAppMessageTh, {
                     variant: 'error',
                  });
               } else console.error('site error');
            })
            .finally(() => {
               setIsLoadingGraph(false);
            });
      }
   };
   const mapOptions = (data) => {
      let xAxisDate = data.map((el) => el.dateTimeLabel);
      let loginCount = data.map((el) => el.loginCount);
      let activityCount = data.map((el) => el.activityCount);
      let redemptionCount = data.map((el) => el.redemptionCount);
      let options = getChartsOptionsDefault();
      options.xAxis[0].data = xAxisDate;
      options.series[0].data = loginCount;
      options.series[1].data = activityCount;
      options.series[2].data = redemptionCount;
      return options;
   };

   const getMultiTable = () => {
      if (mock) {
         setTimeout(() => {
            setMultiTable(topEmployee_mock.MultiTable);
         }, 100);
      } else {
         setIsLoadingMultiTable(true);
         Axios.get('/GSB/dashboard/dashboard/GetTopEmployeeAction')
            .then((resp) => {
               setMultiTable(resp.data.topEmployeeAction);
               // enqueueSnackbar('ดึงข้อมูลตารางสำเร็จ', { variant: 'success' })
            })
            .catch((e) => {
               if (e.response) {
                  const response = e.response.data;
                  enqueueSnackbar(e.response.data.errorAppMessageTh, {
                     variant: 'error',
                  });
               } else {
                  console.error('site error');
               }
            })
            .finally(() => {
               setIsLoadingMultiTable(false);
            });
      }
   };

   const handleDownloadExcel = () => {
      setIsLoadingExcel(true);
      Axios.get(`/GSB/dashboard/dashboard/GetTopEmployeeAction`, {
         responseType: 'blob',
         params: {
            isGenerateReport: true,
         },
      })
         .then((response) => {
            setIsLoadingExcel(false);
            FileSaver.saveAs(
               new Blob([response.data]),
               'แสดงข้อมูลการใช้งานของพนักงานในแต่ละหน่วยงาน.xlsx',
            );
         })
         .catch((err) => {
            enqueueSnackbar('เกิดข้อผิดพลาด กรุณาตรวจสอบข้อมูล', {
               variant: 'error',
            });
         });
   };

   useEffect(() => {
      getMultiTable();
   }, []);
   return (
      <div>
         <Box margin={'10px 0px'} textAlign={'end'}>
            <DownloadPDFButton
               disabled={isLoadingGraph || isLoadingMultiTable}
               to={() => {
                  localStorage.setItem(
                     'report',
                     JSON.stringify({ filtersData, chartData, MultiTable }),
                  );
                  return {
                     pathname: location.pathname + '/report',
                  };
               }}
            />
         </Box>
         <Paper>
            <Box mx={2} pt={2}>
               <Typography variant='h5'>
                  แสดงข้อมูลการใช้งานของพนักงานในแต่ละหน่วยงาน
               </Typography>
               <Filter
                  isLoading={isLoadingGraph}
                  onSubmit={onFiltersSubmit}
                  defaultSubmitFirstParams
               />
            </Box>
            <Box padding={'10px'}>
               {chartData ? (
                  <ReactECharts
                     option={mapOptions(chartData)}
                     style={{ height: 300, width: '100%' }}
                  />
               ) : (
                  <EmptyChart
                     text={'โปรดระบุตัวกรองด้านบนเพื่อแสดงกราฟ'}
                     show={true}
                     height={300}
                  />
               )}
            </Box>
            <Divider variant='middle' />
            <Box marginTop={'10px'} padding={'10px'}>
               <Box textAlign={'end'}>
                  <DownloadExcelButton
                     isLoading={isLoadingExcel}
                     onClick={handleDownloadExcel}
                  />
               </Box>
               {isLoadingMultiTable ? (
                  <LoadingChart show={true} height={300} />
               ) : (
                  <Box display={'flex'}>
                     {MultiTable &&
                        MultiTable.map((item, index) => (
                           <Box
                              className={classes.tablesContainer}
                              key={index}
                              marginRight={
                                 index !== MultiTable.length - 1 ? '10px' : 0
                              }
                              width={'33%'}
                           >
                              <Box
                                 minHeight={100}
                                 fontSize={20}
                                 fontWeight={'bold'}
                                 display={'flex'}
                                 justifyContent={'center'}
                                 textAlign={'center'}
                                 alignItems={'center'}
                              >
                                 {item.listName}
                              </Box>
                              <MaterialTable
                                 columns={[
                                    {
                                       field: 'seq',
                                       title: 'ลำดับ',
                                       sorting: false,
                                       width: 10,
                                    },
                                    {
                                       field: 'name',
                                       title: 'ชื่อสังกัด',
                                       sorting: false,
                                    },
                                    {
                                       field: 'count',
                                       title: 'ครั้ง',
                                       sorting: false,
                                    },
                                 ]}
                                 data={item.employeeAction}
                                 options={{
                                    paging: false,
                                    showTitle: false,
                                    headerStyle: {
                                       fontWeight: 'bold',
                                       backgroundColor: '#F6F6F6',
                                    },
                                    actionsColumnIndex: -1,
                                    addRowPosition: 'first',
                                    actionsCellStyle: {
                                       color: '#ccc',
                                    },
                                    padding: 'dense',
                                    pageSize: 10,
                                    search: false,
                                    toolbar: false,
                                    draggable: false,
                                 }}
                                 localization={{
                                    body: {
                                       editRow: {
                                          deleteText:
                                             'ต้องการลบข้อมูลนี้ใช่หรือไม่?',
                                       },
                                    },
                                    header: { actions: 'ตัวจัดการ' },
                                 }}
                                 icons={tableIcons}
                              />
                           </Box>
                        ))}
                  </Box>
               )}
            </Box>
         </Paper>
      </div>
   );
};

export default PointAndRedeem;
